import type { CalendarEventType } from '@/types/calendarTypes';

export const CALENDAR_EVENT_TYPES = {
  OUTLOOK_VIRTUAL: 'outlook_virtual',
  OUTLOOK_IN_PERSON: 'outlook_in_person',
  BIRTHDAY: 'birthday',
  TASK_REMINDER: 'task_reminder',
  TASK_DEADLINE: 'task_deadline',
} as const satisfies Record<string, CalendarEventType>;
